import style from './style.module.scss';

export interface MessageBoxProps extends React.HTMLAttributes<HTMLDivElement> {
	type: 'info' | 'warning' | 'error';
}

export default function MessageBox({ type, children, className: additionalClasses, ...props }: MessageBoxProps) {
	const divClasses = [style.box, additionalClasses];
	switch (type) {
		case 'info':
			divClasses.push(style['box--info']);
			break;
		case 'warning':
			divClasses.push(style['box--warning']);
			break;
		case 'error':
			divClasses.push(style['box--error']);
			break;
		default:
			break;
	}

	const renderContent = () => {
		if (typeof children === 'string') {
			const paragraphs = children.split('\n').filter((text) => text.trim() !== '');
			return paragraphs.map((paragraph, index) => (
				<p key={index} className={style.box__paragraph}>
					{paragraph}
				</p>
			));
		}
		return children;
	};

	return (
		<div {...props} className={divClasses.join(' ')}>
			{renderContent()}
		</div>
	);
}
